import { IonChip } from '@ionic/react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Chip = styled(IonChip)`
  cursor: pointer;
  border-radius: 8px;
  padding: 0 16px;
  color: ${myPalette.black.main};
  background: ${myPalette.limeGreen.main};
  margin: 0;
  height: 40px;
  font-size: 16px;
  font-weight: 500;

  &:hover {
    background-color: ${myPalette.limeGreen.main};
  }
`

export const DrawerTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${myPalette.dark.main};
  margin-bottom: 16px;
`

export const BalanceItem = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${myPalette.white.main};
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 8px;
  text-decoration: none;
  box-shadow: 0 0 5px ${myPalette.dark.shadowLight};
`

export const StaticBalanceItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${myPalette.white.main};
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 8px;
  box-shadow: 0 0 5px ${myPalette.dark.shadowLight};
`

export const ItemLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const ItemIcon = styled.img`
  width: 36px;
  height: 36px;
`

export const ItemLabel = styled.span`
  font-size: 14px;
  line-height: 18px;
  color: ${myPalette.dark.main};
`

export const ItemAmount = styled.div`
  font-size: 18px;
  color: ${myPalette.midnightBlue.main};
  white-space: nowrap;
`
